import Category from 'common/constants/category'

export interface CategoryState {
  selected: Category
  activated: boolean
}

const initialState: CategoryState = {
  selected: Category.WEAR,
  activated: false,
}

const SET = 'gnb/category/SET'
const CLOSE = 'gnb/category/CLOSE'

export const setCategory = (selected: Category) => {
  return {
    selected,
    type: SET,
  }
}

export const closeCategory = () => {
  return {
    type: CLOSE,
  }
}

const reducers = (state = initialState, action) => {
  switch (action.type) {
    case SET:
      return {
        activated: true,
        selected: action.selected,
      }
    case CLOSE:
      return {
        ...state,
        activated: false,
      }
    default:
      return state
  }
}

export default reducers
